import * as React from "react";
import { ButtonGroup, SxProps, Theme } from "@mui/material";
import { useRef } from "react";
import { AppButton } from "../AppButton";

interface IInputButtonGroupFileInput {
    name?: string;
    accept?: string;
    multiple?: boolean;
    onChange: (files: File[]) => void;
}

export interface IInputButtonGroupButton {
  label: string;
  hidden?: boolean;
  disabled?: boolean;
  fileInput?: IInputButtonGroupFileInput;
  startIcon?: React.ReactNode;
  onClick: (event) => void;
}

export interface IInputButtonGroupProps {
    sx?: SxProps<Theme>;
    showButtons?: boolean;
    buttons: IInputButtonGroupButton[];
};

export const InputButtonGroup = ({ sx, buttons, showButtons = true }: IInputButtonGroupProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleFileClick = (e: React.MouseEvent<HTMLDivElement>) => {
        inputRef.current.click();
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, button: IInputButtonGroupButton) => {
        if (!e.target.files || e.target.files.length < 1) return;
        if (button.fileInput.multiple) {
            button.fileInput.onChange(Array.from(e.target.files));
        } else {
            button.fileInput.onChange([e.target.files[0]]);
        }
    };

    if (!showButtons) return null;

    return (
        <ButtonGroup
            sx={{
                ...sx,
                "marginRight": "-14px",
                "button": {
                    borderRadius: "0",
                    textWrap: "nowrap"
                },
                ".MuiButtonGroup-lastButton": {
                    borderRadius: "0 0.25rem 0.25rem 0",
                },
            }}
        >
            {buttons?.map((button) => (!button.hidden && (
                <AppButton
                    key={button.label}
                    disabled={button.disabled}
                    variant="outlined"
                    startIcon={button.startIcon}
                    onClick={!button.fileInput ? button.onClick : handleFileClick}
                >
                    {button.label}
                    {!!button.fileInput && (
                        <input
                            ref={inputRef}
                            type="file"
                            name={button.fileInput.name}
                            className="file"
                            style={{ display: "none" }}
                            accept={button.fileInput.accept}
                            multiple={button.fileInput.multiple}
                            onChange={(e) => handleFileChange(e, button)}
                        />
                    )}
                </AppButton>
            )))}
        </ButtonGroup>
    );
};